import(/* webpackMode: "eager", webpackExports: ["AboutPageContent"] */ "/vercel/path0/app/about/AboutPageContent.tsx");
